import ky, { type KyInstance } from 'ky';
import { clearAuth, getAuth } from '@/features/auth/authStore';

/*
 * Authenticated API client for report DATA. Auth is unified — one JWT is
 * issued at the central auth endpoint and attached to every region's data
 * backend here. We still keep one ky instance per data base URL (Brazil and
 * the EU cluster are different hosts), memoised so repeat calls reuse it.
 *
 * On 401 (token missing / expired / rejected by any backend) we clear the
 * single token; routing then bounces the user to /login.
 */

const instances = new Map<string, KyInstance>();

export function apiFor(baseUrl: string): KyInstance {
  const cached = instances.get(baseUrl);
  if (cached) return cached;

  const inst = ky.create({
    prefix: baseUrl,
    timeout: 15_000,
    retry: { limit: 1 },
    hooks: {
      beforeRequest: [
        ({ request }) => {
          const entry = getAuth();
          if (entry?.token) request.headers.set('Authorization', `Bearer ${entry.token}`);
        },
      ],
      afterResponse: [
        ({ response }) => {
          if (response.status === 401) clearAuth();
          return response;
        },
      ],
    },
  });
  instances.set(baseUrl, inst);
  return inst;
}
